import React from 'react';
import { Tab } from '@components/atoms/Tab';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import LockPersonOutlinedIcon from '@mui/icons-material/LockPersonOutlined';
import { useFeatureAccess } from '@utils/featureFlag';
import { useTranslation } from '@hooks/useTranslation';

interface ClientTabBarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  projectCount: number;
  // Sprint 25, story-128 (run 5). SUPERINTENDENT keeps read access to the Clients screen (per
  // the UX doc's ruling) but the Client access tab's own toggles are OWNER/ADMIN/PM only — the
  // tab itself is still visible to a SUPERINTENDENT, read-only (`ClientAccessTab`'s `canManage`).
  canViewClientAccess: boolean;
}

export const ClientTabBar: React.FC<ClientTabBarProps> = ({
  activeTab,
  onTabChange,
  projectCount,
  canViewClientAccess,
}) => {
  const { canAccess } = useFeatureAccess();
  const tClients = useTranslation('clients');
  const tabs = [
    {
      id: 'projects',
      name: 'Active Projects',
      leftIcon: <WorkOutlineOutlinedIcon className="w-4 h-4" />,
      count: projectCount,
    },
  ];

  if (canViewClientAccess) {
    tabs.push({
      id: 'clientAccess',
      name: tClients['accessTab'] || 'Client access',
      leftIcon: <LockPersonOutlinedIcon className="w-4 h-4" />,
      count: 0,
    });
  }

  if (canAccess('INVOICES')) {
    tabs.push({
      id: 'currentInvoices',
      name: 'Current Invoices',
      leftIcon: <ReceiptOutlinedIcon className="w-4 h-4" />,
      count: 0,
    });
  }

  return (
    <Tab
      className="mt-6"
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={onTabChange}
    />
  );
};
